import { Form, Formik } from "formik";
import Button from "../UI/Button";
import { toInitialValuesFromSchema } from "../../models/utils";
import TextInput from "../UI/TextInput";
import {
  FINANCE_DECOUPE_FORM_INITIAL_VALUE,
  financeDecoupeValidationSchema,
} from "../../models/financeDecoupe";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { ReactSelect } from "../UI/Select";
import TransactionSplitFieldArray from "../Transaction/TransactionSplitFieldArray";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";
import Callout from "../UI/Callout";
import { ModalDialogFooter } from "../UI/ModalDialog";
import Tooltip from "../UI/Tooltip";
import { Interrogation } from "../UI/Icons";
import useProfileBailleurs from "../../hooks/use-profile-bailleurs";
import { CONTEXTLESS_AFFECTATION_DOMAINS } from "../../utils/constants/balances";

export default function FinanceConfigDecoupeForm({
  config,
  onSubmit,
  onDelete,
}) {
  const { profileBailleurs } = useProfileBailleurs();
  const initialValues = toInitialValuesFromSchema(
    financeDecoupeValidationSchema,
    config,
    FINANCE_DECOUPE_FORM_INITIAL_VALUE,
  );
  const [error, setError] = useState("");

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { resetForm }) => {
        try {
          setError("");
          await onSubmit(values);
          resetForm();
        } catch (e) {
          setError(handleAPIError(e));
        }
      }}
      enableReinitialize={true}
      validationSchema={financeDecoupeValidationSchema}
    >
      <Form>
        <h2 className={"margin0"}>Template de découpe de transaction</h2>

        <TextInput
          type={"text"}
          label={"Nom du template"}
          name={"nom"}
          className={"marginT10"}
          mandatory
        />
        <TextInput
          type={"text"}
          label={
            <>
              Mot clé à comparer{" "}
              <Tooltip
                content={
                  "Si vous renseignez un mot clé, ce template de découpe sera appliqué automatiquement lorsque nous détecterons une transaction qui contient ce mot clé."
                }
              >
                <Interrogation />
              </Tooltip>
            </>
          }
          name={"keyword"}
          className={"marginT10"}
        />
        <ReactSelect
          name="id_profile_nom"
          label="Profil bailleur concerné"
          mandatory
          options={profileBailleurs.map((option) => ({
            label: option.nom_profile,
            value: option.id,
          }))}
          placeholder={"SCI Dupont"}
          className={"marginB10"}
        />
        <TransactionSplitFieldArray
          name={"splits"}
          restrictToDomains={CONTEXTLESS_AFFECTATION_DOMAINS}
        />
        <Callout variant="danger">{error}</Callout>
        <ModalDialogFooter>
          {config && (
            <Button
              type="button"
              variant="secondary"
              onClick={() => onDelete(config.id)}
            >
              Supprimer
            </Button>
          )}
          <FormikSubmitButton>Valider</FormikSubmitButton>
        </ModalDialogFooter>
      </Form>
    </Formik>
  );
}
